import React from "react";
import Layout from "./Layout.js";
import KrnAccordion from "./KrnAccordion.js";
import * as AppStyles from "./css/App.module.css";


function App() {

  return (
    <Layout title="FAQs | KRN Pilates App" desc="Videos">
      <div className={AppStyles.main}>
        <div className={AppStyles.container}>
          <h1 className="h1">FAQs</h1>
          <KrnAccordion />
          <p className={`body-text ${AppStyles.p}`}>If you have additional questions about the KRN Pilates app, please <a href="mailto:paul.endelman@pilates.com" className={AppStyles.a}>contact us</a> or call us at 916-386-6799.</p>
        </div>
      </div>
    </Layout>
  );
}

export default App;
